// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-textarea {
  position: relative;
  width: 100%;
  margin: 15px 0;
}
.custom-textarea .input-textarea {
  width: 100%;
  color: var(--sebrae-gray);
  font-family: var(--font-lato);
  font-weight: 400;
}
.custom-textarea .input-textarea label {
  display: block;
  font-size: 16px;
  line-height: 23px;
  margin-bottom: 2px;
}
.custom-textarea .input-textarea textarea {
  display: block;
  width: 100%;
  height: 116px;
  color: var(--sebrae-gray);
  font-size: 16px;
  font-weight: 400 !important;
  line-height: 16px;
  resize: none;
  background: var(--sebrae-white);
  border-radius: 4px;
  border: 1px solid rgb(182, 191, 200);
  padding: 8px;
}
.custom-textarea .input-textarea textarea::placeholder {
  color: #8b99a7;
}`, "",{"version":3,"sources":["webpack://./src/components/textarea/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,cAAA;AACF;AACE;EACE,WAAA;EACA,yBAAA;EAEE,6BAAA;EACA,gBAAA;AAAN;AAGI;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AADN;AAGI;EACE,cAAA;EACA,WAAA;EACA,aAAA;EACA,yBAAA;EAEE,eAAA;EACA,2BAAA;EAEF,iBAAA;EACA,YAAA;EACA,+BAAA;EACA,kBAAA;EACA,oCAAA;EACA,YAAA;AAHN;AAKM;EACE,cAAA;AAHR","sourcesContent":[".custom-textarea {\n  position: relative;\n  width: 100%;\n  margin: 15px 0;\n\n  .input-textarea {\n    width: 100%;\n    color: var(--sebrae-gray);\n    font: {\n      family: var(--font-lato);\n      weight: 400;\n    }\n\n    label {\n      display: block;\n      font-size: 16px;\n      line-height: 23px;\n      margin-bottom: 2px;\n    }\n    textarea {\n      display: block;\n      width: 100%;\n      height: 116px;\n      color: var(--sebrae-gray);\n      font: {\n        size: 16px;\n        weight: 400!important;\n      }\n      line-height: 16px;\n      resize: none;\n      background: var(--sebrae-white);\n      border-radius: 4px;\n      border: 1px solid rgb(182, 191, 200);\n      padding: 8px;\n\n      &::placeholder {\n        color: #8b99a7;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
